export default function Disclaimer() {
  return (
    <section className="py-20 bg-gradient-to-b from-[#F8FAFB] to-[#F0F4F8]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl border-2 border-[#D1E3EA] overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#E8F1F5] to-[#D1E3EA] px-10 py-8 border-b-2 border-[#B8D4E3]">
            <div className="flex items-center gap-4 mb-3">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#2F7FB7]/20">
                <i className="ri-alert-line text-3xl text-[#2F7FB7]"></i>
              </div>
              <h2 className="text-4xl font-serif text-[#2F7FB7]">Important Disclaimer</h2>
            </div>
            <p className="text-lg text-[#4A5568] font-medium">
              Please read this carefully before using RECOVER
            </p>
          </div>

          {/* Content */}
          <div className="px-10 py-10 space-y-6">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed">
                Recent discussions in the media have highlighted growing concerns regarding the use of AI chatbots for emotional and mental-health support. While AI tools can be helpful for managing everyday stress, improving sleep, and supporting general wellbeing, they are not designed to replace professional mental-health care. Research published in the Harvard Business Review indicates that companionship and therapeutic support are now the primary purposes for which people use AI chatbots, and relying on them during a mental-health crisis may be inadequate or unsafe. OpenAI recently reported that more than one million users express suicidal thoughts to ChatGPT each week, underscoring the need for appropriate professional intervention.
              </p>

              <p className="text-gray-700 leading-relaxed">
                It is important to distinguish between mental wellness and clinical mental-health care. There is a significant difference between seeking support for everyday challenges and experiencing severe emotional distress, deep trauma, clinical depression, or suicidal thoughts.
              </p>

              <div className="bg-[#2F7FB7] rounded-2xl px-8 py-6 my-8">
                <p className="text-white text-xl font-serif font-semibold text-center">
                  RECOVER is a mental-wellness application.
                </p>
              </div>

              <p className="text-gray-700 leading-relaxed">
                Our purpose is to provide guidance, tools, and educational content that support general wellbeing, anxiety and stress management, sleep improvement, and mild mood concerns. RECOVER does not provide clinical, diagnostic, or therapeutic services and should not be used as a substitute for professional mental-health treatment.
              </p>

              <div className="bg-[#FFF4E6] border-l-4 border-[#D4A574] rounded-r-2xl px-8 py-6 my-8">
                <div className="flex items-start gap-4">
                  <i className="ri-heart-pulse-line text-3xl text-[#8B6F47] flex-shrink-0 mt-1"></i>
                  <div>
                    <h3 className="text-xl font-serif text-[#6B5744] mb-3">When to Seek Professional Help</h3>
                    <p className="text-[#8B6F47] leading-relaxed">
                      If you are experiencing significant distress, persistent or worsening mental-health symptoms, trauma-related difficulties, clinical depression, or thoughts of self-harm, it is essential that you seek immediate support from a qualified mental-health professional or crisis service.
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed font-medium text-center text-lg">
                Your wellbeing matters, and professional help is available.
              </p>
            </div>

            {/* Crisis Resources */}
            <div className="bg-gradient-to-br from-[#E8F1F5] to-[#D1E3EA] rounded-2xl px-8 py-6 mt-8">
              <h4 className="text-lg font-serif text-[#2F7FB7] mb-4 flex items-center gap-3">
                <i className="ri-phone-line text-2xl"></i>
                Crisis Support Resources
              </h4>
              <div className="grid md:grid-cols-2 gap-4 text-sm text-gray-700">
                <div>
                  <strong className="text-[#2F7FB7]">Lifeline Australia:</strong>
                  <p>0477 13 11 14 / https://www.lifeline.org.au </p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">National Suicide Prevention Lifeline:</strong>
                  <p>988 (Available 24/7- US Only) </p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">Crisis Text Line:</strong>
                  <p>Text HOME to 741741 (US Only)</p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">International Association for Suicide Prevention:</strong>
                  <p>iasp.info/resources</p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">Emergency Services:</strong>
                  <p>000 or your local emergency number</p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">Psychology Today Directory</strong>
                  <p>https://www.psychologytoday.com </p>
                </div>
                <div>
                  <strong className="text-[#2F7FB7]">British Psychology Society (BPS)</strong>
                  <p>https://www.bps.org.uk </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
